import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#EF4444', '#F59E0B', '#3B82F6', '#10B981', '#8B5CF6', '#EC4899'];

const DiscountAnalysis = ({ data }) => {
    if (!data || !data.by_location || data.by_location.length === 0) return null;

    const labels = data.by_location.map(d => d.location_name);
    const values = data.by_location.map(d => d.total_discount);
    const colors = labels.map((_, i) => COLORS[i % COLORS.length]);

    const chartData = {
        labels,
        datasets: [{
            label: 'Discounts (BHD)',
            data: values,
            backgroundColor: colors,
            borderRadius: 4,
        }],
    };

    const options = {
        responsive: true,
        indexAxis: 'y',
        plugins: {
            legend: { display: false },
        },
        scales: {
            x: {
                title: { display: true, text: 'Discounts (BHD)' },
            },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Discount Analysis</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Discounts</small>
                            <strong>{data.total_discount?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Orders w/ Discount</small>
                            <strong>{data.total_orders_with_discount}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Avg Discount/Order</small>
                            <strong>{data.avg_discount_per_order?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                </div>
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

export default DiscountAnalysis;
